import $ from "jquery";

const preloader = $(".resources-list-preloader"),
  filterForm = $(".resources-filter-form"),
  resourcesListWrapper = $(
    ".resources-list-wrapper .resources-list-posts__wrap"
  ),
  featuredWrapper = $(".resources-list-featured"),
  resourcesFilteredTitle = $(".resources-list-posts h2"),
  resourcesContainer = $(".resources-list-wrapper .container"),
  resourcesCheckbox = $(".filter-form__checkbox"),
  resourcesFeatured = resourcesContainer.data("featured"),
  resourcesFeaturedTitle = resourcesContainer.data("title"),
  resourcesFormSearch = $(".search-resource"),
  filterReset = $("#filter-reset");

filterReset.hide();

function resourcesFilterSubmit() {
  let blogFilterData = filterForm.serialize();
  $.ajax({
    type: "POST",
    url: themeVars.ajaxUrl,
    data: {
      action: "postsLoad",
      data: blogFilterData,
      featured: resourcesFeatured,
      title: resourcesFeaturedTitle,
    },
    beforeSend: function () {
      preloader.fadeIn();
    },
    success: function (response) {
      let parsedResponse = JSON.parse(response);
      blogVars.posts = parsedResponse.posts;
      blogVars.maxPage = parsedResponse.maxPage;
      blogVars.currentPage = parsedResponse.currentPage;
      blogVars.foundPosts = parsedResponse.foundPosts;
      blogVars.postsSearch = parsedResponse.postsSearch;
      blogVars.filtered = parsedResponse.filtered;
      if ($(window).width() < 992) {
        $(".resources-filter__rows").slideUp();
      }

      resourcesListWrapper.fadeOut(function () {
        preloader.fadeOut();
        featuredWrapper.removeClass("paged");
        if (blogVars.filtered || blogVars.postsSearch) {
          $('body').addClass("filtered");
          filterForm.addClass("filtered");
          filterReset.show();
        } else {
          $('body').removeClass("filtered");
          filterForm.removeClass("filtered");
          filterReset.hide();
        }
        if (!blogVars.foundPosts) {
          resourcesFilteredTitle.addClass("none");
        } else {
          resourcesFilteredTitle.removeClass("none");
        }
        resourcesListWrapper.html(parsedResponse.content);
        resourcesListWrapper.fadeIn(1000);
      });
      $("html, body").animate({ scrollTop: 0 }, 0);
    },
  });
}

function clearFilters() {
  blogVars.filtered = false;
  resourcesCheckbox.prop("checked", false);
  resourcesFormSearch.val("");
  resourcesCheckbox.trigger("change");
  filterForm.removeClass("filtered");
  $('body').removeClass("filtered, paged");
  filterReset.hide();
}

filterForm.on("keypress", function (e) {
  let keyPressed = e.keyCode || e.which;
  if (keyPressed === 13) {
    e.preventDefault();
    return false;
  }
});

resourcesCheckbox.on("change", function (e) {
  e.preventDefault();
  filterForm.submit(resourcesFilterSubmit());
});

resourcesFormSearch.on("keydown", function (e) {
  let keyPressed = e.keyCode || e.which;
  if (keyPressed === 13) {
    filterForm.submit(resourcesFilterSubmit());
  }
});

filterReset.on("click", function () {
  clearFilters();
});

$(document).on("click", ".resources-list-wrapper .page-numbers", function (e) {
  e.preventDefault();
  const clicked_url = $(this).attr("href");
  const page = clicked_url.match(/\/page\/(\d*)/);
  let clicked_page = page !== null ? page[1] : 1;
  clicked_page = parseInt(clicked_page, 10);

  $.ajax({
    type: "POST",
    url: themeVars.ajaxUrl,
    data: {
      action: "loadmorePostsAjaxHandler",
      query: blogVars.posts,
      page: clicked_page,
      featured: resourcesFeatured,
    },
    beforeSend: function () {
      preloader.fadeIn();
    },
    success: function (response) {
      preloader.fadeOut();
      if (response) {
        response = $(response).hide().fadeIn();
        resourcesListWrapper.html(response);
        if (clicked_page !== 1) {
          $('body').addClass("paged");
        } else {
          $('body').removeClass("paged");
        }
        $("html, body").animate({ scrollTop: 0 }, 0);
      }
    },
  });
});
